import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TrackUxpEventSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type TrackUxpEventSubscription = { __typename?: 'Subscription', uxpTrackingEvent: { __typename?: 'UxpTrackingEventPayload', id: string, event: string, options: string, payload: string } };


export const TrackUxpEvent = /*#__PURE__*/ gql`
    subscription TrackUxpEvent {
  uxpTrackingEvent {
    id
    event
    options
    payload
  }
}
    ` as unknown as DocumentNode<TrackUxpEventSubscription, TrackUxpEventSubscriptionVariables>;

          

          export const useTrackUxpEventSubscription = (options?:SubscriptionHookOptions<TrackUxpEventSubscription, TrackUxpEventSubscriptionVariables>) => useSubscription(TrackUxpEvent, options);

          

          export type TrackUxpEventSubscriptionOptions = SubscriptionHookOptions<TrackUxpEventSubscription, TrackUxpEventSubscriptionVariables>;

          

          export type TrackUxpEventSubscriptionResult = ReturnType<typeof useTrackUxpEventSubscription>;

          
